import { Button } from '@components/Button';
import { CartItemsCountButton } from '@components/Button/CartItemsCountButton';
import {
  UIContext,
  type UIContextInterface,
} from '@components/Context/UIContext/UIContext';
import { Icons } from '@components/Icons/Icons';
import { TooltipWrapper } from '@components/Tooltip/Tooltip';
import { useCustomer } from '@hooks/customer/useCustomer';
import { type ReactElement, useContext } from 'react';

const ICON_SIZE = '1.75rem';

export const MenuNavBar = ({
  onNavigationBack,
}: {
  onNavigationBack: () => void;
}): ReactElement => {
  const { customer } = useCustomer();
  const {
    setMenuIsOpen,
    setQuickCartIsOpen,
    recentlyViewedIsOpen,
    setRecentlyViewedIsOpen,
    menuBreadcrumbs,
  } = useContext<UIContextInterface>(UIContext);

  const handleCartEvent = () => {
    setMenuIsOpen(false);
    setQuickCartIsOpen(true);
  };

  const handleRecentlyViewedEvent = () => {
    setRecentlyViewedIsOpen(!recentlyViewedIsOpen);
    setMenuIsOpen(false);
  };

  return (
    <div className="sticky left-0 top-0 z-1 flex h-[55px] w-full justify-between bg-grey-light px-4 dark:bg-grey-darkest">
      <div className="flex items-center justify-evenly gap-1">
        <button
          type="button"
          className="gae-menu-back relative mr-2 border-none bg-transparent font-secondary text-4xl text-black hover:cursor-pointer hover:text-orange hover:no-underline focus:cursor-pointer focus:text-orange focus:no-underline dark:text-white dark:hover:text-orange"
        >
          {menuBreadcrumbs.length === 0 ? (
            <Icons.Close onClick={() => setMenuIsOpen(false)} />
          ) : (
            <Icons.Chevron.Left onClick={onNavigationBack} />
          )}
        </button>
        {customer && (
          <TooltipWrapper text="Favourite Products">
            <Button
              href="/account/favourites"
              aria-label="Favourite products"
              className="relative hidden w-10 rounded-full ring-grey-mid ring-offset-2 hover:scale-110
           hover:bg-white hover:text-black hover:ring-1 hover:ring-grey-mid dark:hover:bg-grey-dark dark:hover:text-white xl:flex"
              buttonStyle="tertiary"
              icon={<Icons.Heart.Outline size={ICON_SIZE} />}
            />
          </TooltipWrapper>
        )}
        <TooltipWrapper text="Rewards">
          <Button
            className="w-10 rounded-full ring-grey-mid ring-offset-2 hover:scale-110 hover:bg-white hover:text-black hover:ring-1 hover:ring-grey-mid dark:hover:bg-grey-dark dark:hover:text-white xl:flex"
            buttonStyle="tertiary"
            icon={<Icons.Trophy.Outline size={ICON_SIZE} />}
            href={customer ? '/account/rewards' : '/rewards'}
          />
        </TooltipWrapper>
        <TooltipWrapper text="Recent Products">
          <Button
            onClick={handleRecentlyViewedEvent}
            aria-label="Recent products"
            className="relative hidden w-10 rounded-full ring-grey-mid ring-offset-2 hover:scale-110
          hover:bg-white hover:text-black hover:ring-1 hover:ring-grey-mid dark:hover:bg-grey-dark dark:hover:text-white xl:flex"
            buttonStyle="tertiary"
            icon={<Icons.ReturnArrow size={ICON_SIZE} />}
            data-umami-event-description="recently-viewed-menu-button"
          />
        </TooltipWrapper>
      </div>
      <CartItemsCountButton handleCartEvent={handleCartEvent} />
    </div>
  );
};
